// src/components/common/TeamModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import './TeamCard';

const dummyPlayers = {
  Valorant: [
    {
      name: 'Lucas Arnaiz',
      role: 'Duelista',
      nationality: 'Argentina',
      age: 25,
      image: '/images/players/jett2.png',
    },
    {
      name: 'Gaspar Galindez',
      role: 'Duelista',
      nationality: 'Argentina',
      age: 22,
      image: '/images/players/Fenix.png',
    },
    {
      name: 'Joe Luna',
      role: 'Humos',
      nationality: 'Argentina',
      age: 23,
      image: '/images/players/omen22.png',
    },
     {
      name: 'Braian Vazquez',
      role: 'Iniciador',  
      nationality: 'Argentina',
      age: 24,
      image: '/images/players/Fade.png',
    },
     {
      name: 'Rodrigo Briccola',
      role: 'Centinela',  
      nationality: 'Argentina',
      age: 25,
      image: '/images/players/Cypher.png',
    },
     {
      name: 'Tata Bozzano',
      role: 'Suplente',  
      nationality: 'Argentina',
      age: 26,
      image: '/images/players/iso2.png',
    },

  ],
  'League of Legends': [
    {
      name: 'Sauco',
      role: 'Top Laner',  
      nationality: 'Chile',
      age: 24,
      image: '/images/players/jax.jpg',
    },

    {
      name: 'Santino Santarsierre',
      role: 'JG',  
      nationality: 'Argentino',
      age: 25,
      image: '/images/players/lee.jpg',
    },

    {
      name: 'Lucas Arnaiz',
      role: 'Mid Laner',  
      nationality: 'Argentino',
      age: 26,
      image: '/images/players/ekko.jpg',
    },

    {
      name: 'Sofía Martínez',
      role: 'ADC',  
      nationality: 'Chile',
      age: 27,
      image: '/images/players/jinx.jpg',
    },

    {
      name: 'Jose María',
      role: 'Support',  
      nationality: 'Argentina',
      age: 28,
      image: '/images/players/thresh.jpg',
    },

  ],

    'Counter Strike': [
    {
      name: 'Federico López',
      role: 'AWPer',  
      nationality: 'Chile',
      age: 29,
      image: '/images/players/cs1.jpg',
    },
    {
      name: 'Augusto Paz',
      role: 'Entry Fragger',
      nationality: 'Argentino',
      age: 29,
      image: '/images/players/cs2.jpg',
    },
    {
      name: 'Mauricio Lopez',
      role: 'Lurker',  
      nationality: 'Chile',
      age: 29,
      image: '/images/players/cs3.jpg',
    },  
     {
      name: 'Sebastian Eripa',
      role: 'Anchor',  
      nationality: 'Chile',
      age: 29,
      image: '/images/players/cs4.jpg',
    },  
     {
      name: 'Leonel Messias',
      role: 'IGL',  
      nationality: 'Argentina',
      age: 29,
      image: '/images/players/cs5.jpg',
    },  
     {
      name: 'Mauro Dukiardo',
      role: 'AWPer',  
      nationality: 'Chile',
      age: 29,
      image: '/images/players/cs6.jpg',
    },  

  ],

  'Mobile': [
    {
      name: 'Valentina Rojas',
      role: 'Francotirador',
      nationality: 'Argentina',
      age: 25,
      image: '/images/players/FreeFire2.png',
    },
    {
      name: 'Cecilia Bustamante',
      role: 'Granadero',  
      nationality: 'Colombia',
      age: 25,
      image: '/images/players/FreeFire3.png',
    },
    {
      name: 'Tomas Romieri',
      role: 'Rusher',  
      nationality: 'Venezuela',
      age: 25,
      image: '/images/players/FreeFire5.png',
    },
  ],

  'Otros': [
    {
      name: 'Matías Fernández',
      role: 'Jugador  de FIFA', 
      nationality: 'Argentino',
      age: 25,
      image: '/images/players/Messi2.png',
    }
  ],

};



const TeamModal = ({ open, onClose, team }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const players = dummyPlayers[team] || [];

  useEffect(() => {
    setCurrentIndex(0);
  }, [team]);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % players.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + players.length) % players.length);
  };

  if (!players.length) return null;

  const player = players[currentIndex];

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className="player-modal"
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
            }}
>
        <IconButton className="close-btn" onClick={onClose}>
              <div className="close-button" onClick={onClose}>
              ✕ <span className="esc-label">ESC</span>
              </div>
          <CloseIcon />
        </IconButton>

          

    


        <Box
          className="player-card"
          sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2
             }}
              >
          <IconButton onClick={handlePrev} className="nav-arrow left">
            <ArrowBackIosIcon />
          </IconButton>

          <Box
          className="player-info"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
              }}
          >
            <img src={player.image} alt={player.name} className="player-image" />
            <Typography variant="h5" className="player-name">{player.name}</Typography>
            <Typography variant="subtitle1">Rol: {player.role}</Typography>
            <Typography variant="subtitle2">Edad: {player.age} años</Typography>
            <Typography variant="subtitle2">Nacionalidad: {player.nationality}</Typography>
          </Box>

          <IconButton onClick={handleNext} className="nav-arrow right">
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default TeamModal;
